import React, { useMemo } from 'react';

import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
  useStyleConfig,
} from '@chakra-ui/react';

export interface ButtonProps extends ChakraButtonProps {
  active?: boolean;
  leftIcon?: any;
  rightIcon?: any;
  iconFamily?: any;
  textVariant?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'full-width';
  variant?: 'primary.teal' | 'primary.blue' | 'secondary.teal' | 'secondary.blue' | 'ghost.teal' | 'ghost.blue';
}

const sizes = {
  xs: {
    px: 3,
    h: 9,
  },
  sm: {
    px: 4,
    h: 10,
  },
  md: {
    px: 5,
    h: 12,
  },
  lg: {
    px: 6,
    py: 3,
    h: 12,
  },
  'full-width': {
    w: '100%',
    h: 12,
  },
};

export default function Button({
  variant = 'primary.teal',
  disabled,
  size = 'md',
  children,
  isLoading,
  ...rest
}: ButtonProps) {
  const [rank, parsedVariant] = useMemo(() => variant?.split('.'), [variant]);

  const type = useMemo(
    () => ({
      primary: 'PrimaryButton',
      secondary: 'SecondaryButton',
      ghost: 'GhostButton',
    }),
    [],
  );

  const styles = useStyleConfig(type[rank], {
    variant: parsedVariant,
    disabled,
  });

  return (
    <ChakraButton
      display="flex"
      __css={styles}
      _loading={{
        color: 'system.ongoing.default',
      }}
      justifyContent="center"
      alignItems="center"
      disabled={disabled || isLoading}
      isLoading={isLoading}
      py={2}
      _focus={null}
      _disabled={{
        opacity: 1,
        cursor: 'not-allowed',
        boxShadow: 'none',
      }}
      {...sizes[size]}
      {...rest}>
      {children}
    </ChakraButton>
  );
}
